import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import {googleAnalytics} from "./config";
import ReactGA from "react-ga";
import Homepage from "./pages/Homepage/Homepage";
import Page from "./pages/Page/Page";
import Admin from "./pages/Admin/Admin";
import AdminCompetitions from "./pages/Admin/AdminCompetitions";
import AdminCompetitionEdit from "./pages/Admin/AdminCompetitionEdit";
import AdminCompetitionDetails from "./pages/Admin/AdminCompetitionDetails";
import Competition from "./pages/Competition/Competition";
import CompetitionEnter from "./pages/CompetitionEnter/CompetitionEnter";
import CompetitionVote from "./pages/CompetitionVote/CompetitionVote";
import Video from "./pages/Video/Video";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import { redirects } from './config'

const ScrollToTop = () => {
	window.scrollTo(0, 0);
	return null;
};

class Routing extends Component {
	
	componentWillMount() {
		ReactGA.initialize(googleAnalytics.account, { debug: false });
	}
	
	render() {
		return (
			<BrowserRouter>
			<div>
			
			<Route component={ScrollToTop} />
			<Route path="*" render={({location}) => {
				ReactGA.pageview(location.pathname + location.search);
				return null;
			}} />
			
			<Switch>
			{redirects.map((value, index) => {
				return (<Route key={index} exact path={value.short} render={() => (
						<Redirect to={value.real}/>
        )}/>		)
			})
			}
			<Route exact path="/:lang?" component={({ match }) => (
				<Homepage
					lang={match.params.lang}
				/>
      )} />
			<Route
			path="/:lang?/page/:uid"
			component={({ match }) => (
				<Page
				uid={match.params.uid}
				lang={match.params.lang}
				/>
			)}
			/>
			<Route
			path="/competition/:slug/enter/:entryId?"
			component={({ match }) => (
				<CompetitionEnter
				slug={match.params.slug}
				entryId={match.params.entryId}
				key={match.params.entryId}
				lang={match.params.lang}
				/>
			)}
			/>
			<Route
			path="/competition/:slug/vote/:emailHash"
			component={({ match }) => (
				<CompetitionVote
				slug={match.params.slug}
				emailHash={match.params.emailHash}
				key={match.params.emailHash}
				lang={match.params.lang}
				/>
			)}
			/>
			<Route
			path="/competition/:slug"
			exact
			component={({ match }) => (
				<Competition slug={match.params.slug} key={match.params.slug} lang={match.params.lang} />
			)}
			/>
			<Route
			path="/competition/:slug/video/:videoId"
			exact
			component={({ match }) => (
				<Video
				slug={match.params.slug}
				key={match.params.slug}
				videoId={match.params.videoId}
				lang={match.params.lang}
				/>
			)}
			/>
			<Route exact path="/admin" component={Admin} />
			<Route
			exact
			path="/admin/competitions"
			component={AdminCompetitions}
			/>
			<Route
			path="/admin/competition/new"
			component={() => <AdminCompetitionEdit />}
			/>
			<Route
			path="/admin/competition/:id/edit"
			component={({ match }) => (
				<AdminCompetitionEdit
				competitionId={match.params.id}
				key={match.params.id}
				/>
			)}
			/>
			<Route
			path="/admin/competition/:id"
			component={({ match }) => (
				<AdminCompetitionDetails
				competitionId={match.params.id}
				key={match.params.id}
				/>
			)}
			/>
			<Route path="*" component={() => <ErrorPage />} />
			</Switch>
			</div>
			</BrowserRouter>
		);
	}
}

export default Routing;



// WEBPACK FOOTER //
// ./src/Routing.js